import { Component } from '@angular/core';
import { FxRatesComponent } from '../fx-rates/fx-rates.component';
import { PershingTranslationService } from '@pershing/pershing-core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'fx-rates-link',
    templateUrl: './fx-rates-link.component.html'
})
export class FxRatesLinkComponent {
    constructor(public dialog: MatDialog, private translationService: PershingTranslationService) { }
    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-rateboard', 'node_modules/@pershing/nxi-ng-rateboard/lib');
    }
    openFXRate() {
        this.dialog.open(FxRatesComponent, {
            width: '510px',
            disableClose: true,
            panelClass: ['modal', 'ag-Group_Modal']
        });
    }
}
